module.exports = __webpack_public_path__ + "img/943.1663b535.png";